'use client'

import { useEffect } from 'react'
import * as Sentry from '@sentry/nextjs'
import SiteError from '@/components/reference/SiteError'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Log to Sentry
    Sentry.captureException(error)
    console.error('Root error:', error)
  }, [error])

  return (
    <SiteError
      error={error}
      reset={reset}
      title='Oops! Something went wrong'
      message={
        "We're sorry, but something unexpected happened. Please try again."
      }
      links={[{ href: '/', label: 'Go home', reload: true }]}
    />
  )
}
